import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Visalia',
  description: 'Licensed electrician serving Visalia, CA. C-10 certified electrical contractor for residential and commercial electrical work in Visalia and Tulare County.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Visalia',
    addressRegion: 'CA',
    postalCode: '93291',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.3302', longitude: '-119.2921' },
  url: 'https://electriciansolutionsfresno.com/areas/visalia',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Visalia', '@id': 'https://en.wikipedia.org/wiki/Visalia,_California' },
};

const faqs = [
  {
    q: 'Do you provide electrician services in Visalia, CA?',
    a: 'Yes! Electrician Solutions Fresno serves all of Visalia, CA and Tulare County. Our C-10 licensed electricians handle residential panel upgrades, EV charger installations, commercial electrical fit-outs, and 24/7 emergency electrical services throughout Visalia, from downtown to the Sequoia gateway neighborhoods.',
  },
  {
    q: 'Can you handle large commercial electrical projects in Visalia?',
    a: 'Absolutely. We handle commercial electrical installations across Visalia including office fit-outs on Mooney Blvd, retail electrical work, restaurant systems, warehouse installations, and three-phase power for Visalia industrial parks.',
  },
  {
    q: 'How soon can a Visalia electrician be dispatched?',
    a: 'For emergency electrical services in Visalia, we typically dispatch a licensed electrician within 60–90 minutes. For scheduled work, we offer next-day appointments for most Visalia residential and commercial projects.',
  },
  {
    q: 'Do you install smart home systems in Visalia?',
    a: 'Yes. We install complete smart home systems in Visalia including smart lighting, smart thermostats optimized for the hot San Joaquin Valley summers, home automation, energy monitoring, and smart security systems.',
  },
  {
    q: 'What areas of Visalia do you cover?',
    a: 'We serve all Visalia neighborhoods including downtown Visalia, the Mooney Blvd commercial corridor, Northwest Visalia, Linda Vista, Ivanhoe area, Goshen, and rural Tulare County properties.',
  },
  {
    q: 'Do you handle agricultural electrical work near Visalia?',
    a: 'Yes. We serve farms and agricultural properties throughout Tulare County near Visalia, including pump station wiring, three-phase power for irrigation systems, agricultural panel upgrades, and cold storage electrical installations.',
  },
];

const VisaliaPage = () => (
  <AreaTemplate
    area="Visalia"
    areaSlug="visalia"
    state="CA"
    county="Tulare County"
    population="141,000+"
    description="Electrician Solutions Fresno provides top-rated C-10 licensed electrical services across all of Visalia, CA and Tulare County. As the largest city between Los Angeles and Fresno, Visalia deserves the region's best electrical contractor. From Sequoia-gateway neighborhoods to the Mooney Blvd commercial corridor, our certified Visalia electricians deliver expert electrical work on every project."
    neighborhoods={['Downtown Visalia', 'Northwest Visalia', 'Linda Vista', 'Mooney Blvd Area', 'Goshen', 'Ivanhoe', 'Southeast Visalia', 'Tulare County Rural']}
    nearbyAreas={[
      { name: 'Tulare', slug: 'tulare' },
      { name: 'Hanford', slug: 'hanford' },
      { name: 'Porterville', slug: 'porterville' },
      { name: 'Fresno', slug: 'fresno' },
      { name: 'Dinuba', slug: 'dinuba' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/722ce3307ae2483dedabca9dd3b9bcb3.jpg"
    heroImageAlt="Licensed Electrician in Visalia CA"
    teamImage="https://readdy.ai/api/search-image?query=Professional%20electricians%20in%20branded%20uniforms%20standing%20proudly%20in%20front%20of%20Visalia%20California%20downtown%20area%20with%20palm%20trees%20central%20park%20and%20classic%20California%20architecture%20blue%20sky%20showing%20community%20roots%20and%20professionalism&width=800&height=600&seq=visalia_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Visalia CA"
    schema={schema}
  />
);

export default VisaliaPage;
